export default "__VITE_ASSET__DSngH0hw__"